module.exports = __webpack_public_path__ + "img/info-outline-blue.023c4495.svg";